import React, { useEffect, useState } from "react";
import Table from "../../../components/table/Table";
import { useApiClient } from "../../../shared/customHooks";
import { applicationsListTable } from "../../../shared/tableObjects/admin/applicationsListTable";
import { PageHeader } from "../../../components/header/PageHeader";
import CreateApplicationButtonsManager from "../../../components/CreateApplicationButtonsManager";
import { RoleId } from "../../../shared/enums/Role";
export default function ApplicationsList() {
  const apiClient = useApiClient("AdminApplication");
  const headerText = [
    {
      class: "p-0 m-0 flex items-center",
      value: "List of Applications",
      icon: "list-icon icon-spec",
    },
  ];

  const { fetchData } = useApiClient("UserManagement", { identity: true });
  const [assessors, setAssessors] = useState<any>({ options: [] });

  useEffect(() => {
    fetchData(`GetActiveUsersByRoles/${RoleId.Assessor},${RoleId.Manager}`).then((res) => {
      const options = (res.data as any[]).map((user) => user.displayName).sort();
      setAssessors(options);
    });
  }, []);

  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table">
        <CreateApplicationButtonsManager />
        <Table apiClient={apiClient} route="applicationList" label={""} columns={applicationsListTable("applications", assessors)} />
        <p className="fieldadv mb-5">
          Note: the em dash (—) in the "KPI" column indicates a null value, which indicates the action required is not with the Application team
        </p>
      </div>
    </>
  );
}
